import { type SgWorkspace } from "../../api/types.ts";
import { client } from "../../api/client.ts";
import { WorkspaceBoundary, getHomePaths } from "@sg-protect/shell";
import { type PropsWithChildren, useCallback } from "react";
import { generatePath } from "react-router";
import { usePaths } from "../../paths.ts";

export function ModuleWorkspaceBoundary({ children }: PropsWithChildren) {
    const paths = usePaths({ prefillWorkspaceId: false });

    const resolveDestination = useCallback(
        (workspace: SgWorkspace) => {
            if (workspace.isPartner) {
                return getHomePaths(workspace.id).root;
            }

            return generatePath(paths.home, { workspaceId: workspace.id });
        },
        [paths.home]
    );

    return (
        <WorkspaceBoundary resolveDestination={resolveDestination} client={client}>
            {children}
        </WorkspaceBoundary>
    );
}
